import { Button, Spin } from 'antd'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import noWithdrawalsImage from '../../../assets/images/no-withdrawals.png'
import pendingWithdrawalImage from '../../../assets/images/pending-withdrawal.png'
import WeekendNotification from '../../../atoms/WeekendNotification'
import { RootState } from '../../../redux'
import { ICurrentUserLoadDetailPayload } from '../../../redux/currentUser/currentUserActions'
import { WITHDRAWAL_STATE } from '../../../utils/enums'

type IWithdrawalsDashboardButton = {
	contractShareLink?: string | null
}

const WithdrawalsDashboardButton: FC<IWithdrawalsDashboardButton> = ({ contractShareLink }) => {
	const { t } = useTranslation()
	const isMobile = useMediaQuery({ maxWidth: 991 })

	const currentUser: ICurrentUserLoadDetailPayload = useSelector((state: RootState) => state.currentUser.detail)

	const handleCreateWithdrawalDrawerOpen = () => {
		const openButton: HTMLButtonElement | null = document.querySelector('#create-withdrawal-drawer-open-button')
		openButton?.click()
	}

	if (!currentUser.record) return null

	return currentUser.isLoading ? (
		<div className={'h-80 flex justify-center items-center'}>
			<Spin size={'large'} />
		</div>
	) : (
		<>
			{isMobile ? (
				<>
					<Button
						type={'primary'}
						shape={'round'}
						block={true}
						className={'shadow-md mb-6'}
						disabled={currentUser.record.withdrawalState === WITHDRAWAL_STATE.PENDING}
						onClick={handleCreateWithdrawalDrawerOpen}
					>
						{t('loc:employee|Request a Withdrawal')}
					</Button>
					<div className={'max-w-md mx-auto'}>
						<WeekendNotification />
					</div>
				</>
			) : (
				<div className={'flex flex-col items-center text-center gap-2 bg-white p-10 rounded-md'}>
					{currentUser.record.withdrawalState === WITHDRAWAL_STATE.PENDING ? (
						<>
							<img src={pendingWithdrawalImage} alt={''} width={'230'} />
							<span className={'text-40 font-600'}>{t('loc:employee|Pending request')}</span>
							{!contractShareLink && (
								<p className={'text-17 font-400'}>
									<span className={'inline lg:block'}>{t('loc:employee|A withdrawal request has been sent')}, </span>
									<span className={'inline lg:block'}>{t("loc:employee|we will let you know once it's approved")}.</span>
								</p>
							)}
						</>
					) : (
						<>
							<img src={noWithdrawalsImage} alt={''} width={'230'} />
							<span className={'text-40 font-600'}>{`${t('loc:general|WageNow')}!`}</span>
							<p className={'text-22 font-700 opacity-60%'}>{t('loc:employee|Get your hard earned money without waiting')}.</p>
						</>
					)}
					{!contractShareLink && (
						<>
							<Button
								type={'primary'}
								shape={'round'}
								className={'shadow-md mt-3 mb-6'}
								disabled={currentUser.record.withdrawalState === WITHDRAWAL_STATE.PENDING}
								onClick={handleCreateWithdrawalDrawerOpen}
							>
								{t('loc:employee|Request a Withdrawal')}
							</Button>
							<WeekendNotification />
						</>
					)}
					{/* TODO: Check if contract is active, not only status as it is right now */}
					{contractShareLink && (
						<div className='flex flex-col items-center bg-red-light py-8 px-6 xxl:px-16 rounded-md shadow-md'>
							<div className='text-22 font-700 text-center mb-3'>{t('loc:employee|Finish signing the contract to make your funds available.')}</div>
							<div className='text-base text-center mb-4'>
								{t("loc:employee|WageNow Benefit is free for employees. You don't pay for the service or withdrawals.")}
							</div>
							<Button
								type={'default'}
								shape={'round'}
								block={true}
								href={contractShareLink}
								target='_blank'
								className={'shadow-md text-20 font-700 text-white bg-neutral-800'}
							>
								{t('loc:employee|Go to contracts')}
							</Button>
						</div>
					)}
				</div>
			)}
		</>
	)
}

export default WithdrawalsDashboardButton
